<template v-if="groupTree && groupTree.length > 0">
    <div class="row">
        <div class="col-sm-12">
            <div ref="wrap" >
            <el-tree ref="treeRef" tabindex="0" @focus="focusOnTree"
                     style="max-width: 626px; margin-bottom: 15px;"
                     :data="groupTree"
                     highlight-current="true"
                     show-checkbox="true"
                     node-key="groupNumber"
                     :props="defaultTreeProps"
                     @check-change="getCheckedNodes"
                     />
            </div>
        </div>
        <div class="col-sm-12">
            <button v-if="ids.length" class="btn btn-rectangle" @click="clearAll">{{ conf.labels.emptyall }}</button>
        </div>
    </div>
    

</template>


<script>
    import { ref, onMounted } from 'vue';
    import { mapActions, mapState, mapMutations } from 'vuex';

    export default {

        components: {

        },
        data: () => ({
            defaultTreeProps: {
                children: 'children',
                label: 'groupName',
                id: 'groupNumber'
            },
            treeRef: null,
            wrap: null
        }),
        props: {

        },
        computed: {
            ...mapState([
                'checkAllId',
                'checkAllEventDone',
                'conf',
                'groupTree',
                'ids',
                'focusValue'
            ]),
        },
        methods: {
            ...mapActions([

            ]),
            ...mapMutations([
                'setIds',
            ]),
            buildVisibleList() {
                const visible = [];
                const traverse = (nodes, parent = null) => {
                    if (!nodes) return;
                    for (const node of nodes) {
                        visible.push({ key: node.groupNumber, data: node, parent });
                        if (node.children && node.children.length) traverse(node.children, node);
                    }
                }
                traverse(this.groupTree);
                return visible;
            },
            focusNodeByIndex(list, idx) {
                const item = list[idx];
                if (!item) return;
                const tree = this.$refs.treeRef;
                if (!tree) return;

                tree.setCurrentKey(item.key);
                // ensure parent expanded
                if (item.parent) tree.expandNode(item.parent, true)
            },
            focusOnTree() {
                const visible = this.buildVisibleList();
                if ((this.focusValue.length == 1) && !Array.from(this.focusValue[0].classList).includes("el-tree-node")) {
                    this.focusNodeByIndex(visible, 0);
                    $('.el-tree-node:first-child').focus();
                } else if (this.focusValue[1] && (!Array.from(this.focusValue[1].classList).includes("el-tree-node")) || Array.from(this.focusValue[0].classList).includes("btn")) {
                    this.focusNodeByIndex(visible, 0);
                    $('.el-tree-node:first-child').focus(); 
                }
                
                    
                
                
            },
            onKeydown(e) {
                //Outdated alternate keyboard navigation for group tree
                const tree = this.$refs.treeRef;
                if (!tree) return;
                const visible = this.buildVisibleList();
                const currentKey = tree.getCurrentKey();
                const idx = visible.findIndex(n => n.key === currentKey);

                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.focusNodeByIndex(visible, (idx >= 0 ? idx + 1 : 0));
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.focusNodeByIndex(visible, (idx > 0 ? idx - 1 : 0));
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    const node = tree.getNode(currentKey);

                    tree.store.nodesMap[node.key].expanded = true;
                    //tree.store.nodeExpand(node);
                    //node && tree.expandNode(node.data, true);
                } else if (e.key === 'ArrowLeft') {
                    e.preventDefault()
                    const node = tree.getNode(currentKey)
                    tree.store.nodesMap[node.key].expanded = false;
                    //node && tree.collapseNode(node.data, true)
                } else if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    const node = tree.getNode(currentKey)
                    if (node) {
                        const checked = (tree.getCheckedKeys() || []).includes(node.key)
                        tree.setCheckedKeys(checked ? [] : [node.key], false)
                    }
                }
            },
            getCheckedNodes() {

                const checkedNodes = this.$refs.treeRef.getCheckedNodes();
                let groupNumbers = [];
                checkedNodes.forEach(function (o) {
                    groupNumbers.push(o.groupNumber);
                });
                this.setIds(groupNumbers);
            },
            checkAll() {
                const allKeys = [];

                const traverse = (nodes) => {
                    nodes.forEach(node => {
                        allKeys.push(node.groupNumber);
                        if (node.children && node.children.length > 0) {
                            traverse(node.children);
                        }
                    });
                };

                traverse(this.groupTree);
                //this.treeRef = allKeys;
                this.$refs.treeRef.setCheckedKeys(allKeys);
            },
            clearAll() {
                this.$refs.treeRef.setCheckedKeys([]);
            }
        },
        mounted() {
            // Access the ref after component has mounted
            this.treeRef = this.$refs.treeRef;
            this.wrap = this.$refs.wrap;

        },
        created() {

        }
    };
</script>